if (!customElements.get('custom-video')) {
  class CustomVideo extends HTMLElement {
    constructor() {
      super();
      this.video = this.querySelector('#custom-video');
      this.muteBtn = this.querySelector('#mute-btn');
      this.pauseBtn = this.querySelector('#pause-btn');

      this.muteIcon = this.querySelector('#mute-icon');
      this.unmuteIcon = this.querySelector('#unmute-icon');
      this.pauseIcon = this.querySelector('#pause-icon');
      this.playIcon = this.querySelector('#play-icon');

      // Initialize event listeners
      this.init();
    }

    // Initialize all button event listeners
    init() {
      this.muteBtn.addEventListener('click', this.handleMuteToggle.bind(this));
      this.pauseBtn.addEventListener('click', this.handlePlayToggle.bind(this));
    }

    // Handle mute/unmute toggle
    handleMuteToggle() {
      this.video.muted = !this.video.muted;
      this.updateMuteIcon();
    }

    // Update mute/unmute icon visibility
    updateMuteIcon() {
      const isMuted = this.video.muted;
      this.muteIcon.style.display = isMuted ? 'block' : 'none';
      this.unmuteIcon.style.display = isMuted ? 'none' : 'block';
    }

    // Handle play/pause toggle
    handlePlayToggle() {
      if (this.video.paused) {
        this.video.play();
      } else {
        this.video.pause();
      }
      this.updatePlayIcon();
    }

    // Update play/pause icon visibility
    updatePlayIcon() {
      const isPaused = this.video.paused;
      this.pauseIcon.style.display = isPaused ? 'none' : 'block';
      this.playIcon.style.display = isPaused ? 'block' : 'none';
    }

  }

  customElements.define('custom-video', CustomVideo);
}
